import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { ContatosRealizadosDTO } from "types/dto/GestaoCobrancaContatoDTO";

export const usePostContatosRealizados = () => {
  const onSuccess = (response: any) => {
    queryClient.invalidateQueries(["contatos-realizados"]);
    toast.success("Registro salvo com sucesso.");
  };

  const onError = () => {
    toast.error("Erro ao salvar registro.");
  };

  return usePost<ContatosRealizadosDTO>({
    url: api.gestaoCobranca.postRegitrarContatoRealizado,
    onSuccess,
    onError,
  });
};
